import { Button, Form, FormField, Input, Link, Modal, Select, Table, Textarea } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useState } from 'react';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;

interface ItemContext {
    idContext?: number;
    context?: string;
    module?: string;
}
export const SystemRoutingIAPage = () => {
    const { menu, data } = useGlobalState();
    const [sideOpen, setSideOpen] = useState(false);
    const [contexts, setContexts] = useState<ItemContext[]>([]);
    const [context, setContext] = useState<ItemContext>();
    const [selectedContext, setSelectedContext] = useState<any>({ value: "IA.Globals", label: "IA.Globals", module: "IA.Globals" });

    useEffect(() => {
        handleRefresh()
    }, []);
    const ctx = [
        { value: "IA.Globals", label: "IA.Globals", module: "IA.Globals" },
        { value: "IABookings", label: "IABookings", module: "IABookings." },
        { value: "IAEquipments", label: "IAEquipments", module: "IAEquipments." },
        { value: "IAFlights", label: "IAFlights", module: "IAFlights." },
        { value: "IAMovements", label: "IAMovements", module: "IAMovements." },
        { value: "IASQL", label: "IASQL", module: "IASQL." },
        { value: "IANotes", label: "IANotes", module: "IANotes." },
        { value: "IAHelpers", label: "IAHelpers", module: "IAHelpers." },
    ]


    const handleAddContext = async (ctx: any) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/ia/add',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(ctx),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setContexts(data.contexts)
                setContext(undefined)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }
    const handleRefresh = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/ia/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({}),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setContext(undefined)
                setContexts(data.contexts)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }
    const filteredContexts = contexts.filter(ctx => ctx.module.startsWith(selectedContext.module));
    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={sideOpen}
            onSplitPanelToggle={({ detail }) => setSideOpen(detail.open)}


            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header variant='h2' actions={
                            <SpaceBetween direction='horizontal' size="xs">
                                <Button variant="primary" onClick={() => setContext({ idContext: 0 })}>Agregar</Button>
                                <Favorites />
                            </SpaceBetween>}>
                            Maestro de Parametros</Header>
                        <FormField label="Contexto">
                            <Select selectedOption={selectedContext} options={ctx}
                                onChange={({ detail }) => {
                                    setSelectedContext(detail.selectedOption);
                                }}
                            />
                        </FormField>



                        <Table
                            variant="embedded"
                            columnDefinitions={[
                                {
                                    id: "module",
                                    header: "Módulo",
                                    cell: item => <FormField label={<Link onClick={() => setContext(item)}>{item.module}</Link>}
                                        info={item.idContext}
                                    >{item.context.length > 300 ? item.context.substr(0, 300) + "..." : item.context}</FormField>,
                                },
                            ]}
                            items={filteredContexts ?? []}
                            empty={
                                <Box
                                    margin={{ vertical: "xs" }}
                                    textAlign="center"
                                    color="inherit"
                                >
                                    <SpaceBetween size="m">
                                        <b>Sin contextos</b>
                                    </SpaceBetween>
                                </Box>
                            }
                        />
                    </SpaceBetween>
                    {!!context && (
                        <Modal visible={!!context} onDismiss={() => setContext(undefined)} closeAriaLabel="Close modal" header={context?.idContext == 0 ? "Agregar Contexto" : "Editar Contexto"}>
                            <Form actions={
                                <Button variant="primary" onClick={() => {
                                    handleAddContext(context)
                                }}>Guardar</Button>}
                                secondaryActions={
                                    <Button variant="link" onClick={() => setContext(undefined)}>Cancelar</Button>
                                }>

                                <SpaceBetween direction="vertical" size="xs">
                                    <FormField label="Módulo">
                                        <Input autoComplete="off" value={context?.module ?? ""} onChange={(e) => setContext({ ...context, module: e.detail.value })} />
                                    </FormField>
                                    <FormField label="Contexto">
                                        <Textarea rows={20} value={context.context} onChange={(e) => {
                                            setContext({
                                                ...context,
                                                context: e.detail.value
                                            })
                                        }} />
                                    </FormField>
                                </SpaceBetween>
                            </Form>
                        </Modal>
                    )}

                </>
            }
        />
    );
};